import { render, staticRenderFns } from "./LmFormBuilder.vue?vue&type=template&id=c58046b2&scoped=true&"
import script from "./LmFormBuilder.vue?vue&type=script&lang=js&"
export * from "./LmFormBuilder.vue?vue&type=script&lang=js&"
import style0 from "./LmFormBuilder.vue?vue&type=style&index=0&id=c58046b2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c58046b2",
  null
  
)

export default component.exports